module.exports = __webpack_public_path__ + "img/icon-top-arrow-opacity.8ae362e0.svg";